import { render, staticRenderFns } from "./DeliveryAddressList.vue?vue&type=template&id=6e4a26c1&scoped=true&"
import script from "./DeliveryAddressList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAddressList.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryAddressList.vue?vue&type=style&index=0&id=6e4a26c1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a26c1",
  null
  
)

export default component.exports